import React from "react";
import {Helmet} from "react-helmet-async";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import {Container} from "react-bootstrap";
import ProjectOverviewTableHandler from "../../components/projecten/ProjectResultTableHandler";

const ProjectResults = () => (
    <React.Fragment>
        <Helmet title="Projectresultaten"/>
        <Container fluid className="p-0">
            <ProjectOverviewTableHandler/>
        </Container>
    </React.Fragment>
);

export default ProjectResults;
